
window.addEventListener("message", receiveMessage, false); // get info from iFrame

function receiveMessage(event) {
  setTimeout(() => {
    var frame = document.getElementById("form");
    var height = event.data[0] + 20;
    var width = event.data[1];
    if (frame) {
      frame.style.width = width + "px";
      frame.style.height = height + "px";
      frame.classList.add('is-loaded');
    }
  },0);
}

function doScrolling(elementY, duration) {
  var startingY = window.pageYOffset;
  var diff = elementY - startingY;
  var start; // Bootstrap our animation - it will get called right before next frame shall be rendered.

  window.requestAnimationFrame(function step(timestamp) {
    if (!start) start = timestamp; // Elapsed milliseconds since start of scrolling.

    var time = timestamp - start; // Get percent of completion in range [0, 1].

    var percent = Math.min(time / duration, 1);
    window.scrollTo(0, startingY + diff * percent); // Proceed with animation as long as we wanted it to.

    if (time < duration) {
      window.requestAnimationFrame(step);
    }
  });
}

var scrollClick = document.querySelectorAll(".header__right a");
scrollClick.forEach(function(k, v) {
  var formId = scrollClick[v].getAttribute("href");
  if (formId.indexOf("#") !== -1) {
    scrollClick[v].addEventListener("click", function(e) {
      e.preventDefault();
      var formEl = document.querySelector(formId);
      var formPos = formEl.getBoundingClientRect();
      var scrollY = formPos.top - 120;
      doScrolling(scrollY, 600);
    });
  } else {
    return;
  }
});